import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generarReporteTardanza = (asistencias) => {
  const doc = new jsPDF();

  if (asistencias.length === 0) {
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('Autosegurosa', 14, 20);

    doc.setFontSize(14);
    doc.setFont('helvetica', 'normal');
    doc.text('No hubieron tardanzas en este período.', 14, 40);

    doc.save('reporte_tardanzas.pdf');
    return;
  }

  const asistenciasPorUsuario = {};
  asistencias.forEach((a) => {
    if (!asistenciasPorUsuario[a.cedula]) {
      asistenciasPorUsuario[a.cedula] = {
        nombre: a.nombre,
        sucursal: a.sucursal,
        registros: [],
      };
    }
    asistenciasPorUsuario[a.cedula].registros.push(a);
  });

  let first = true;
  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const obtenerDiaSemana = (fecha) => diasSemana[fecha.getDay()];

  Object.entries(asistenciasPorUsuario).forEach(([cedula, data]) => {
    if (!first) doc.addPage();
    first = false;

    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('Reporte de Tardanzas - Argent Investments (YOKOMO)', 14, 15);

    doc.setFontSize(16);
    doc.setFont('helvetica', 'normal');
    doc.text(`Empleado: ${data.nombre}`, 14, 25);
    doc.setFontSize(12);
    doc.text(`Cédula: ${cedula}`, 14, 32);
    doc.text(`Sucursal: ${data.sucursal}`, 14, 39);

    let totalTardanzaMin = 0;

    const tableData = data.registros.map((asistencia) => {
      const fechaObj = new Date(asistencia.fecha_hora);
      const diaSemana = obtenerDiaSemana(fechaObj);

      const fechaStr = `${fechaObj.getDate().toString().padStart(2, '0')}/${(fechaObj.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${fechaObj.getFullYear()}`;

      const horaPermitida = asistencia.hora_entrada_permitida || '-';
      const horaReal = asistencia.hora_entrada_real || '-';
      const tardanzaMin = asistencia.tardanza_minutos || 0;

      totalTardanzaMin += tardanzaMin;

      // Convertir minutos a formato "xh y ymin"
      const horas = Math.floor(tardanzaMin / 60);
      const minutos = tardanzaMin % 60;
      const tardanzaStr = `${horas > 0 ? `${horas}h ` : ''}${minutos}min`;

      return [
        diaSemana,
        fechaStr,
        horaPermitida,
        horaReal,
        tardanzaStr
      ];
    });

    autoTable(doc, {
      head: [['Día', 'Fecha', 'Hora Permitida', 'Hora Entrada', 'Tardanza']],
      body: tableData,
      startY: 45,
    });

    const totalHoras = Math.floor(totalTardanzaMin / 60);
    const totalMinutos = totalTardanzaMin % 60;
    const totalStr = `${totalHoras > 0 ? `${totalHoras}h ` : ''}${totalMinutos}min`;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`Total de tiempo tarde: ${totalStr}`, 14, doc.lastAutoTable.finalY + 10);
  });

  doc.save('reporte_tardanzas.pdf');
};
